"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APDebounceText = void 0;
var makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
var debounce_1 = __importDefault(require("@material-ui/core/utils/debounce"));
var react_1 = __importDefault(require("react"));
var useStyles = makeStyles_1.default({
    searchInputBox: {
        padding: "8px 12px",
        fontSize: "12px",
        lineHeight: "16px",
        letterSpacing: "1",
        color: "#828282",
        border: "1px solid #bdbdbd",
        borderRadius: "4px",
    },
});
function APDebounceText(_a) {
    var onChanged = _a.onChanged, _b = _a.placeholder, placeholder = _b === void 0 ? "SEARCH" : _b, style = _a.style, value = _a.value;
    var classes = useStyles();
    var debounceSearch = debounce_1.default(function (text) {
        onChanged(text);
        // return text;
    }, 150);
    return react_1.default.createElement("input", { type: "text", placeholder: placeholder, className: classes.searchInputBox, style: __assign({ background: "#f2f2f2", letterSpacing: "1px", border: "none", color: "#111" }, style), onChange: function (event) {
            var text = event.target.value;
            debounceSearch(text);
        } });
}
exports.APDebounceText = APDebounceText;
